module.exports = __webpack_public_path__ + "img/feature-03.0b13116e.png";